
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { IShortUser } from '@/model/shortInterfaces';

@Component({ name: 'UserIntegrationStatus' })
export default class UserIntegrationStatus extends Vue {
  @Prop({ required: true })
  protected user!: IShortUser;
}
